// extracted by mini-css-extract-plugin
export var CareerDetailsCloseBtn = "careersDetails-module--CareerDetailsCloseBtn--defc4";
export var CareerDetailsContainer = "careersDetails-module--CareerDetailsContainer--bc0cb";
export var CareerDetailsContent = "careersDetails-module--CareerDetailsContent--dad45";
export var CareerDetailsExperience = "careersDetails-module--CareerDetailsExperience--063cc";
export var CareerDetailsHeader = "careersDetails-module--CareerDetailsHeader--74f38";
export var CareerDetailsHeaderWrap = "careersDetails-module--CareerDetailsHeaderWrap--62d9e";
export var CareerDetailsLocation = "careersDetails-module--CareerDetailsLocation--26772";
export var CareerDetailsUploadBtn = "careersDetails-module--CareerDetailsUploadBtn--f6e28";
export var CareerDetailsUploads = "careersDetails-module--CareerDetailsUploads--c4c6c";
export var CareerDetailsWrap = "careersDetails-module--CareerDetailsWrap--cf0a4";
export var bgVideo = "careersDetails-module--bgVideo--5432d";
export var richTextIndent = "careersDetails-module--richTextIndent--5e8ce";
export var richTextListItem = "careersDetails-module--richTextListItem--2abee";
export var richTextListItemIndent = "careersDetails-module--richTextListItemIndent--bb14e";
export var searchBar = "careersDetails-module--searchBar--83d05";
export var searchBarDiv = "careersDetails-module--searchBarDiv--03e75";
export var shareButton = "careersDetails-module--shareButton--29d4e";
export var shareCopyDiv = "careersDetails-module--shareCopyDiv--387d7";
export var shareIcon = "careersDetails-module--shareIcon--896f3";
export var svgContainer = "careersDetails-module--svgContainer--ac0aa";